import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid3x3GapFill } from 'react-bootstrap-icons';
import { useAuth } from '../contexts/AuthContext';

const FOOTER_LINKS = [
    { label: 'Privacy', path: '/privacy' },
    { label: 'Terms', path: '/terms' },
    { label: 'Contact Us', path: '/contact' },
    { label: 'Feedback', path: '/feedback' },
    { label: 'Suggestions', path: '/suggestions' }
];

export function SiteNotice(): React.ReactElement
{
    const navigate = useNavigate();
    const { user, isAuthenticated } = useAuth();
    const isSuperAdmin = String(user?.role || '').trim().toLowerCase() === 'superadmin';
    const showFeedbackAction = isAuthenticated && !isSuperAdmin;

    return (
        <section className="site-notice-shell" aria-label="Product contact notice">
            <div className="site-notice">
                <div className="site-notice-left">
                    <Grid3x3GapFill size={16} className="site-notice-icon" />
                    <span className="site-notice-copy">
                        © {new Date().getFullYear()} AcceliQA · Accelirate Inc. - Want something we have not implemented? Need changes? Contact us at{' '}
                        <a className="site-notice-link" href="mailto:AcceliQADev@accelirate.com">
                            AcceliQADev@accelirate.com
                        </a>
                    </span>
                </div>
                {showFeedbackAction && (
                    <button
                        type="button"
                        className="site-notice-action"
                        onClick={() => navigate('/feedback')}
                    >
                        Send Feedback
                    </button>
                )}
            </div>
        </section>
    );
}

function SiteFooter(): React.ReactElement
{
    const navigate = useNavigate();
    const { user, isAuthenticated } = useAuth();
    const isSuperAdmin = String(user?.role || '').trim().toLowerCase() === 'superadmin';
    const footerLinks = FOOTER_LINKS.filter((link) => link.path !== '/feedback' || (isAuthenticated && !isSuperAdmin));

    return (
        <footer className="site-footer" aria-label="Site footer">
            <ul className="site-footer-links">
                {footerLinks.map((link) => (
                    <li key={link.label}>
                        <button
                            className="site-footer-link"
                            type="button"
                            onClick={() => navigate(link.path)}
                        >
                            {link.label}
                        </button>
                    </li>
                ))}
            </ul>
        </footer>
    );
}

export default SiteFooter;
